/**
 * Results Page
 * Route Component für die Test-Ergebnisse
 */

import ResultsComponent from '../components/ResultsComponent';

export function ResultsPage() {
  return <ResultsComponent />;
}








